import React, { useEffect, useState } from 'react';

import { MdDoneAll, MdOutlineCircleNotifications } from 'react-icons/md';
import { IoCheckmarkDoneCircleOutline } from 'react-icons/io5';
import { GiSandsOfTime } from 'react-icons/gi';
import { IoCloseCircleOutline } from 'react-icons/io5';
import { IoArrowForwardOutline } from 'react-icons/io5';
import { useRouter } from 'next/router';
import { useUser } from 'hooks';
import staffRequestApi from 'api/staffRequest';
import { useSelector } from 'react-redux';
import { getSelectedCentre } from 'store/master';
import { handleToastError } from 'helpers';
import { getOnBoardDateFilter } from 'store/global';
import {
  STAFF_JOURNEY_STATUS,
  STAFF_JOURNEY_TYPE,
} from 'modules/StaffRequest/constants';
import moment from 'moment';

const OnboardStatus = () => {
  const router = useRouter();
  const user = useUser();
  const [count, setCount] = useState();
  const selectedCentre = useSelector(getSelectedCentre);
  const onBoardDate = useSelector(getOnBoardDateFilter);

  const fetchDashboardCount = async (begin, end) => {
    try {
      let params = {
        ...(begin && { begin: new Date(begin)?.toISOString() }),
        ...(end && { end: new Date(end)?.toISOString() }),
        ...(selectedCentre && { courseCentre: selectedCentre?._id }),
      };

      const response = await staffRequestApi.getDashboardCount(params);
      setCount(response);
    } catch (error) {
      handleToastError(error);
    }
  };

  const handleDatefilter = () => {
    const formattedRange = onBoardDate
      .map((date) => moment(date).format('DD/MM/YYYY'))
      .join(' - ');

    return onBoardDate.length === 1
      ? `${formattedRange} - ${formattedRange}`
      : formattedRange;
  };
  useEffect(() => {
    if (onBoardDate?.length === 2) {
      fetchDashboardCount(
        new Date(onBoardDate[0]),
        new Date(onBoardDate[1]).setHours(23, 59, 59),
      );
    }
  }, [router?.query, selectedCentre, onBoardDate]);
  return (
    <>
      <div className="status-onboading-card">
        <section className="d-flex justify-content-between align-items-center mb-1">
          <h6 className="onboard-dashboard-title m-0">
            {user?.type.name === 'HR'
              ? 'Manage Staff Request'
              : 'Staff Request'}
          </h6>
          <p
            className="m-0"
            style={{ cursor: 'pointer' }}
            onClick={() =>
              router.push(
                user?.type.name === 'HR'
                  ? '/manage-staff-request'
                  : `/staff-request/create`,
              )
            }
          >
            <span style={{ color: '#CC171D' }}>
              {user?.type.name === 'HR'
                ? 'Manage Staff Request'
                : 'New Staff Request'}
            </span>
            <IoArrowForwardOutline color="#CC171D" />
          </p>
        </section>
        <section
          className="d-flex justify-content-between align-items-center"
          style={{ gap: '20px' }}
        >
          <div
            className="notified-status-card w-100 d-flex flex-column justify-content-between"
            style={{ cursor: 'pointer' }}
            onClick={() =>
              router.push(
                user?.type.name === 'HR'
                  ? `/manage-staff-request?statusId=NOTIFIED&createdAt=${handleDatefilter()}~Between`
                  : `/staff-request?statusId=NOTIFIED&createdAt=${handleDatefilter()}~Between`,
              )
            }
          >
            <section className="d-flex justify-content-between align-items-center">
              <div className="onboard-status-circle">
                <MdOutlineCircleNotifications size={25} color="#347FF1" />
              </div>
              <p className="onboard-allstatus-counts m-0">
                {count?.notifiedCount}
              </p>
            </section>
            <section className="heading_text_subtitle_stage">Notified</section>
          </div>
          <div
            className="rejected-status-card w-100 d-flex flex-column justify-content-between"
            style={{ cursor: 'pointer' }}
            onClick={() =>
              router.push(
                user?.type.name === 'HR'
                  ? `/manage-staff-request?statusId=REJECTED&createdAt=${handleDatefilter()}~Between`
                  : `/staff-request?statusId=REJECTED&createdAt=${handleDatefilter()}~Between`,
              )
            }
          >
            <section className="d-flex justify-content-between align-items-center">
              <div className="onboard-status-circle">
                <IoCloseCircleOutline size={25} color="#CC171D" />
              </div>
              <p className="onboard-allstatus-counts m-0">
                {' '}
                {count?.rejectedCount}
              </p>
            </section>
            <section className="heading_text_subtitle_stage">Rejected</section>
          </div>
          <div
            className="approved-status-card w-100 d-flex flex-column justify-content-between"
            style={{ cursor: 'pointer' }}
            onClick={() =>
              router.push(
                user?.type.name === 'HR'
                  ? `/manage-staff-request?statusId=${STAFF_JOURNEY_STATUS.ACCOUNT_SETUP_PENDING
                  }&createdAt=${handleDatefilter()}~Between`
                  : `/staff-request?statusId=${STAFF_JOURNEY_STATUS.ACCOUNT_SETUP_PENDING
                  }&createdAt=${handleDatefilter()}~Between`,
              )
            }
          >
            <section className="d-flex justify-content-between align-items-center">
              <div className="onboard-status-circle">
                <MdDoneAll size={25} color="#0DA678" />
              </div>
              <p className="onboard-allstatus-counts m-0">
                {count?.AccountSetupCount}
              </p>
            </section>
            <section className="heading_text_subtitle_stage">
              Account Setup Pending
            </section>
          </div>
          <div
            className="waiting-status-card w-100 d-flex flex-column justify-content-between"
            style={{ cursor: 'pointer' }}
            onClick={() =>
              router.push(
                user?.type.key === 'HR'
                  ? `manage-staff-request?statusId=${STAFF_JOURNEY_TYPE.PENDING_FOR_ACCEPTANCE
                  }&createdAt=${handleDatefilter()}~Between`
                  : `/staff-request?statusId=${STAFF_JOURNEY_TYPE.PENDING_FOR_ACCEPTANCE
                  }&createdAt=${handleDatefilter()}~Between`,
              )
            }
          >
            <section className="d-flex justify-content-between align-items-center">
              <div className="onboard-status-circle">
                <GiSandsOfTime size={25} color="#D5880A" />
              </div>
              <p className="onboard-allstatus-counts m-0">
                {count?.AcceptanceCount}
              </p>
            </section>
            <section className="heading_text_subtitle_stage">
              Requester Action Pending
            </section>
          </div>
          <div
            className="completed-status-card w-100 d-flex flex-column justify-content-between"
            style={{ cursor: 'pointer' }}
            onClick={() =>
              router.push(
                user?.type.name === 'HR'
                  ? `/manage-staff-request?statusId=COMPLETED&createdAt=${handleDatefilter()}~Between`
                  : `/staff-request?statusId=COMPLETED&createdAt=${handleDatefilter()}~Between`,
              )
            }
          >
            <section className="d-flex justify-content-between align-items-center">
              <div className="onboard-status-circle">
                <IoCheckmarkDoneCircleOutline size={25} color="#26e7a6" />
              </div>
              <p className="onboard-allstatus-counts m-0">
                {count?.completedCount}
              </p>
            </section>
            <section className="heading_text_subtitle_stage">
              Account Created
            </section>
          </div>
        </section>
      </div>
    </>
  );
};

export default OnboardStatus;
